import React, { useState, useEffect } from 'react';
import { useGlobalContext } from '../../context'; // Update the import path as needed
import "./Footer.css";
import logoImg from "../../images/footer-logo.png";
import { HiOutlineMenuAlt4 } from "react-icons/hi";
import { FaFacebookSquare, FaLinkedin, FaYoutube } from 'react-icons/fa';
import { BsTwitterX } from 'react-icons/bs'; // Import Twitter X icon from react-icons/bs

const Footer = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  const [searchTerm, setSearchTerm] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const username = localStorage.getItem('username');
    setIsLoggedIn(!!username); // Check if username exists in localStorage
  }, []);



  return (
    <nav className='footer' id="footer">
      <div className='container footer-content flex'>
        <div className='brand-and-toggler flex flex-sb'>
          <a href="/index" className='footer-brand flex'>
            <img src={logoImg} style={{width: "135px"}} salt="site logo" />
            <span className='text-uppercase fw-7 fs-24 ls-1'></span>
          </a>
          <div className="social-icons">
            <a href="https://www.linkedin.com/company/ksgafal" target="_blank" rel="noopener noreferrer">
              <FaLinkedin className="social-icon" />
            </a>
            <a href="https://www.youtube.com/@ksgafal" target="_blank" rel="noopener noreferrer">
              <FaYoutube className="social-icon" />
            </a>
            {/* Replace X icon with BsTwitterX icon */}
            <a href="https://twitter.com/KSGAFAL" target="_blank" rel="noopener noreferrer">
              <BsTwitterX className="social-icon" />
            </a>
            <a href="https://www.facebook.com/KSGAFAL/" target="_blank" rel="noopener noreferrer">
              <FaFacebookSquare className="social-icon" />
            </a>
          </div>
          {/* <button type="button" className='footer-toggler-btn' onClick={handleFooter}>
            <HiOutlineMenuAlt4 size={35} style={{
              color: ` "#fff"`
            }} />
          </button> */}
        </div>

        <div >
          <ul className="footer-nav">
            <li className='nav-item'>
              <span className='nav-linkk text-uppercase text-white fs-22 fw-6 ls-1'> جميع الحقوق محفوظة لمجمع الملك سلمان العالمي للغة العربية © {new Date().getFullYear()}.</span>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}

export default Footer;